module.exports = __webpack_public_path__ + "img/pic28_3.381499fd.png";